import { zodResolver } from "@hookform/resolvers/zod";
import { type DefaultValues, useForm } from "react-hook-form";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import type { AnyZodObject, z } from "zod";

export const useCalculatorForm = <TSchema extends AnyZodObject>(
	getSchema: (t: TranslateFunction) => TSchema,
	defaultValues: DefaultValues<z.input<TSchema>>,
) => {
	const { t } = useResource();

	return useForm<z.input<TSchema>, unknown, z.output<TSchema>>({
		resolver: zodResolver(getSchema(t)),
		defaultValues,
		mode: "onChange",
	});
};
